<template>
  <div class="my-profile-page">
    <h1>{{$t('grzl.t1')}}</h1>
    <div class="my-profile-page-main">
      <div class="profile-items">
        <div class="profile-card profile-username">
          <h3>{{$t('grzl.t2')}}</h3>
          <h4>{{profiledata.username}}<button @click="editusername = true"><i class="el-icon-edit-outline"></i> {{$t('grzl.t3')}}</button></h4>
        </div>
        <div class="profile-card profile-telephone" v-if="false">
          <h3>{{$t('grzl.t4')}}</h3>
          <h4><span>{{profiledata.telnum}}</span><button v-if="false" @click="edittelnumber = true"><i class="el-icon-edit-outline"></i> {{$t('grzl.t3')}}</button></h4>
        </div>
        <div class="profile-card profile-email">
          <h3>{{$t('grzl.t5')}}</h3>
          <h4><span>{{profiledata.email}}</span></h4>
        </div>
        <div class="profile-card profile-company">
          <h3>{{$t('grzl.t6')}}</h3>
          <h4><span>{{profiledata.company}}</span></h4>
        </div>
        <div class="profile-card profile-passwd">
          <h3>{{$t('grzl.t7')}}</h3>
          <h4><span>{{profiledata.passwd}}<button @click="editpassword = true"><i class="el-icon-edit-outline"></i> {{$t('grzl.t3')}}</button></span></h4>
        </div>
      </div>
    </div>

    <el-dialog
      class="editusernamebox"
      :title="$t('new.t12')"
      :visible.sync="editusername"
      width="460px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <el-form :rules="rules" ref="form" status-icon :model="form" label-width="auto" size="small">
        <el-form-item :label="$t('new.t13')" prop="newusername">
          <el-input v-model="form.newusername" required></el-input>
        </el-form-item>
      </el-form>
      <span>{{ $t('new.t14') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editusername = false" size="small">{{ $t('new.t15') }}</el-button>
        <el-button type="primary" @click="updateUserName('form')" size="small">{{ $t('new.t16') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      class="editusernamebox"
      :title="$t('changepasswd.changepasswd')"
      :visible.sync="editpassword"
      width="460px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <el-form status-icon label-width="auto" size="small">
        <el-form-item :label="$t('changepasswd.oldpasswd')">
          <el-input v-model="passwdform.oldpasswd" @input="chkpasswdtips = ''" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('changepasswd.newpasswd')">
          <el-input v-model="passwdform.newpasswd" @input="chkpasswdtips = ''" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('changepasswd.chknewpasswd')">
          <el-input v-model="passwdform.chkpasswd" @input="chkpasswdtips = ''" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span style="display: block; height: 30px; line-height:30px; color:#ff0000; font-size:12px;">{{ chkpasswdtips }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button 
          @click="editpassword = false; 
                  chkpasswdtips = ''; 
                  passwdform.oldpasswd = ''; 
                  passwdform.newpasswd = '';
                  passwdform.chkpasswd = ''" 
          size="small"
        >
          {{ $t('el.datepicker.cancel') }}
        </el-button>
        <el-button type="primary" @click="updatePassword()" size="small">{{ $t('el.datepicker.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog 
      class="signup-page-dialog" 
      :visible.sync="updatepasswdsuccess"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="true"
      :append-to-body="true"
    >
      <span class="modal-success-icon"></span>
      <p>{{ $t('changepasswd.changepasswdsuccessful') }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn-bluelight" @click="reLogin()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>    

    <el-dialog
      class="edittelnumberbox"
      :visible.sync="edittelnumber"
      width="960px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <h2 slot="title">修改手机号码
      <el-divider></el-divider></h2>
      <el-steps :active="edittelnumberstep" finish-status="success">
        <el-step title="验证身份"></el-step>
        <el-step title="修改手机"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>

      <div class="verifytelnum" v-if="checkoldtelnum">
        <el-form label-width="150px" size="small" :model="codeform" :rules="oldtelrules" ref="oldtelrules">
          <el-form-item label="手机号码">
            <el-row>
              <el-col :span="12">{{ profiledata.telnum }}</el-col>
              <el-col :span="12">
                <el-button class="getcodebtn" @click="onGetSmsCode(profiledata.telnum)" :disabled="btngetcodedisabled">{{ getcode }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码" prop="oldcode" :error="errormsg">
            <el-input placeholder="输入验证码" v-model="codeform.oldcode"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="verifyOldTelnumber('oldtelrules')" size="small" class="nextbtn">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="setnewtelnum" v-if="getnewtelnumbox">
        <el-form :model="newform" size="small" :rules="newrules" ref="newrules">
          <el-form-item prop="telnum">
            <el-input v-model="newform.telnum" placeholder="输入新的手机号码"></el-input>
          </el-form-item>
          <el-form-item prop="codenum" :error="errormsg">
            <el-row :gutter="15">
              <el-col :span="12">
                <el-input v-model="newform.telcode" placeholder="输入验证码"></el-input>
              </el-col>
              <el-col :span="12">
                <el-button class="getcodebtn" @click="onGetNewSmsCode(newform.telnum, 'newrules')" :disabled="btngetcodedisabled1">{{ getcode1 }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button @click="verifyNewTelnumber('newrules')" size="small" class="setcodebtn">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="updatetelnumsuccess" class="updatetelnumsuccess">
        <h2>修改成功</h2>
        <p>您的手机号已经修改成功！</p>
        <button type="button" @click="successUpdateTelnum()">完成</button>
      </div>

    </el-dialog>   

  </div>
</template>

<script>
export default {
  data() {

    let checkName = (rule, value, callback) => {
      let len = 0;
      // let regEn = /[`~!@#$%^&*()_+<>?:"{},./;'[]]/im
      // let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[]]/im
      let pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
      for (let i=0; i<value.length; i++) {   
        let c = value.charCodeAt(i);   
        //单字节加1   
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {   
          len++   
        } else {   
          len+=2
        }
      }
      if ((len < 5 && len> 0) || len > 20 || pattern.test(value)) {
        callback(new Error('中英文+数字,5-20个字符，一个中文字为两个字符'));
      } else {
        callback();
      }
    };

    let checkphone = (rule, value, callback) => {
      let rex = /^1(3|4|5|6|7|8|9)\d{9}$/
      if(false === rex.test(this.newform.telnum)){
        callback(new Error('手机号码输入有误'));
      }else{
        callback();
      }
    };

    return{
      form:{
        newusername: '',
      },

      passwdform: {
        oldpasswd: '',
        newpasswd: '',
        chkpasswd: ''
      },

      chkpasswdtips: '',
      updatepasswdsuccess: false,

      checkoldtelnum: true, //step1
      getnewtelnumbox: false, //step2
      updatetelnumsuccess: false, //step3

      btngetcodedisabled: false,
      btngetcodedisabled1: false,
      getcode: this.$t('Signup.getcode'),
      getcode1: this.$t('Signup.getcode'),
      currenttelnum: '',
      verifycode: '',
      editusername: false,
      edittelnumber: false,
      editpassword: false,
      edittelnumberstep: 0,
      isvipuser: false,
      userstatus: '',
      showdialog: false,
      smscode: '',
      profiledata : {
        username : window.localStorage.getItem('name') ? JSON.parse(window.localStorage.getItem('name')).val : '--',
        telnum : window.localStorage.getItem('phone') ? JSON.parse(window.localStorage.getItem('phone')).val : '--',
        email : window.localStorage.getItem('email') ? JSON.parse(window.localStorage.getItem('email')).val : '--',
        company : window.localStorage.getItem('company') ? JSON.parse(window.localStorage.getItem('company')).val : '--',
        passwd : '******',
      },
      rules: {
        newusername: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: checkName, trigger: 'blur'}
        ],
        verifycode: [{
          required: true, 
          message: '请输入验证码'
        }]
      },
      errormsg: '',
      codeform:{
        oldcode: ''
      },
      oldtelrules: {
        oldcode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      },

      newform: {
        telnum: '',
        telcode: ''
      },

      newrules: {
        telnum: [{
          required: true, 
          message: '请输入手机号码'
        },{
          validator: checkphone, 
          trigger: 'blur'
        }],
        telcode: [{
          required: true, 
          message: '请输入验证码'
        }]
      }


    }
  },
  mounted(){
    this.getUserInfo()
  },
  methods: {

    /**
     * 获取用户信息
     */
    getUserInfo: function(){
      let that = this
      let url = that.API_URL + '/v3/users/info'
      $.ajax({
        url: url,
        type: "GET",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        changeOrigin: true,
        success: function(rex) {
          console.log('getUserInfo-success',rex)
        },
        error: function(response) {
          console.log('getUserInfo-error', response)
        }
      })
    },

    /**
     * 修改用户名
     */
    updateUserName: function(formName){
      let that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let url = that.API_URL + '/v3/users/update'
          let putdata = {
            username : that.form.newusername,
          }
          $.ajax({
            url: url,
            type: "PUT",
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
            },
            data: putdata,
            changeOrigin: true,
            success: function(rex) {
              console.log('getUserInfo-success',rex)
              if(rex.success){
                that.editusername = false
                that.setLocalStorage( "name", that.form.newusername )
                that.$alert('用户名修改成功','', {
                  confirmButtonText: '确定',
                  callback: action =>{
                    that.profiledata.username = that.form.newusername
                  }
                });              
              }
            },
            error: function(response) {
              console.log('getUserInfo-error', response)
            }
          })
        }
      })
    },

    /**
     * 修改密码
     */
    updatePassword: function(){
      let that = this
      if(that.passwdform.oldpasswd == ''){
        that.chkpasswdtips = that.$t('changepasswd.tipsoldpasswd')
        return
      }
      if(that.passwdform.newpasswd == ''){
        that.chkpasswdtips = that.$t('changepasswd.tipsnewpasswd')
        return
      }
      if(that.passwdform.chkpasswd == ''){
        that.chkpasswdtips = that.$t('changepasswd.tipserrchkpasswd')
        return
      }
      if(that.passwdform.newpasswd != '' 
        && that.passwdform.chkpasswd != '' 
        && that.passwdform.newpasswd != that.passwdform.chkpasswd){
        that.chkpasswdtips = that.$t('changepasswd.tipserrchkpasswd')
        return
      }
      if(that.passwdform.newpasswd != ''){
        let rexxx = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{5,20}$/
        if(!rexxx.test(that.passwdform.newpasswd)){
          that.chkpasswdtips = '密码只包含字母、数字和符号，至少包含以下两种：字母、数字、符号'
          return
        }
      }
      
      let url = that.API_URL + '/v3/users/updatepwd'
      let querydata = {
        email: that.profiledata.email,
        oldpassword: that.passwdform.oldpasswd,
        newpassword: that.passwdform.newpasswd
      }
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(querydata),
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        contentType: "application/json",
        success: function(data) {
          console.log(data)
          if(data.code/1 === 0) {
            that.editpassword = false; 
            that.chkpasswdtips = ''
            that.passwdform.oldpasswd = ''
            that.passwdform.newpasswd = ''
            that.passwdform.chkpasswd = ''
            that.updatepasswdsuccess = true
            let currentlan = localStorage.getItem("localeLanguage")
            localStorage.clear()
            window.localStorage.setItem('localeLanguage', currentlan)
          }
          if(data.code/1 === 400) {
            that.chkpasswdtips = that.$t('changepasswd.tipserrpasswd')
          }
        },
        error: function(response) {
          console.log(response)
        }
      })

    }, 

    /**
     * 重新登录
     */
    reLogin: function(){
      let that = this
      that.$router.push({ path: "/Login" })
    },

    /**
     * 修改手机号码
     */
    verifyOldTelnumber: function(formName){
      let that = this
      console.log(that.codeform.oldcode)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.onCheckSmsCode(that.codeform.oldcode)
        } 
      });
      //that.onCheckSmsCode(that.verifycode)
      //if (that.edittelnumberstep++ > 2) this.edittelnumberstep = 0;
    },

    /**
     * 校验手机验证码
     */
    onCheckSmsCode: function(code){
      let that = this
      let url = that.API_URL + '/v3/users/sms'
      let checkcodedata = {
        telnum: that.profiledata.telnum,
        smsid: code
      }
      $.ajax(url, {
        type: "PUT",
        data: checkcodedata,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(data) {
          console.log("验证码通过", data)
          //that.confirmSignup()
          that.edittelnumberstep = 1
          that.checkoldtelnum = false
          that.getnewtelnumbox = true

          that.getcode = that.$t('Signup.getcode')
          that.btngetcodedisabled = false
          that.getnewtelnum = true
          //window.clearInterval(interval);

        },
        error: function(response) {
          //that.$message('验证码错误')
          console.log("验证码错误",response)
          that.errormsg = ''
          that.errormsg = '验证码错误'
        }
      })
    },

    /**
     * 获取验证码
     */
    onGetSmsCode: function(telnum){
      let that = this
      
      /**
       * 获取验证码倒计时 60 秒
       */
      var num = 60, str = null;
      var interval = setInterval(function() {
        that.btngetcodedisabled = true
        num--
        str =  that.$tc('Signup.resendin', num)
        that.getcode = str
        if (num < 1) {
          that.getcode = that.$t('Signup.getcode')
          that.btngetcodedisabled = false
          that.getnewtelnum = true
          window.clearInterval(interval);
        }
      }, 1000)

      console.log(telnum)
      let url = that.API_URL + '/v3/users/sms'
      let smscodedata = {
        telnum: telnum
      }
      $.ajax(url, {
        type: "GET",
        data: smscodedata,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        contentType: "application/json",
        success: function(data) {
          console.log(data.message)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 新手机验证码
     */
    onGetNewSmsCode: function(telnum, formName){
      let that = this
      
      that.$refs[formName].validate((valid) => {
        if (valid) {

          /**
           * 获取验证码倒计时 60 秒
           */
          let num1 = 60, str = null;
          let interval1 = setInterval(function() {
            that.btngetcodedisabled1 = true
            num1--
            str =  that.$tc('Signup.resendin', num1)
            that.getcode1 = str
            if (num1 < 1) {
              that.getcode1 = that.$t('Signup.getcode')
              that.btngetcodedisabled1 = false
              that.getnewtelnum = true
              window.clearInterval(interval1);
            }
          }, 1000);

          let url = that.API_URL + '/v3/users/sms'
          let smscodedata = {
            telnum: telnum
          }

          $.ajax(url, {
            type: "GET",
            data: smscodedata,
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            contentType: "application/json",
            success: function(data) {
              console.log(data.message)
            },
            error: function(response) {
              console.log(response)
            }
          })
        }
      })
    },

    /**
     * 校验手机验证码
     */
    onCheckNewSmsCode: function(code){
      let that = this
      let url = that.API_URL + '/v3/users/sms'
      let checkcodedata = {
        telnum: that.newform.telnum,
        smsid: code
      }
      $.ajax(url, {
        type: "PUT",
        data: checkcodedata,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(data) {
          console.log("验证码通过", data)
          //that.confirmSignup()
          that.setNewTel()
        },
        error: function(response) {
          //that.$message('验证码错误')
          console.log("验证码错误",response)
          that.errormsg = ''
          that.errormsg = '验证码错误'
        }
      })
    },

    /**
     * 修改手机号码
     */
    verifyNewTelnumber: function(formName){
      let that = this
      console.log(that.newform.telcode)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.onCheckNewSmsCode(that.newform.telcode)
        } 
      });
      //that.onCheckSmsCode(that.verifycode)
      //if (that.edittelnumberstep++ > 2) this.edittelnumberstep = 0;
    },

    /**
     * 更新手机号码
     */
    setNewTel: function(){
      let that= this
      let url = that.API_URL + '/v3/users/update'
      let putdata = {
        telnum : that.newform.telnum,
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: putdata,
        changeOrigin: true,
        success: function(rex) {
          console.log('getUserInfo-success',rex)
          if(rex.success){
            that.edittelnumberstep = 2
            that.getnewtelnumbox = false
            that.updatetelnumsuccess = true              
            }
        },
        error: function(response) {
          console.log('getUserInfo-error', response)
        }
      })
    },

    /**
     * 完成修改密码
     */
    successUpdateTelnum: function(){
      this.checkoldtelnum= true
      this.updatetelnumsuccess= false
      this.getnewtelnumbox= false
      this.edittelnumberstep= 1
      this.edittelnumber = false
    }

  }
}
</script>

<style>
.my-profile-page{
  padding-top: 10px;
}
.my-profile-page h1{
  font-size: 24px;
  font-weight: normal;
  line-height: 39px;
  border-bottom: 1px solid #ddd;
  background-image: url(../../assets/img/Personal/icon_profile.svg);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 40px;
}
.my-profile-page-main{
  margin-top: 30px;
}
.box-card{
  width: 450px;
  height: 350px;
}
.box-card .el-card__header{
  border-bottom: none;
  height: 120px;
	padding: 0;
	font-size: 24px;
	color: #fff;
	height: 120px;
	background-image: url(../../assets/img/not-vip-tips-bg.png);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: 100% auto;
}
.box-card .el-card__header h2{
  text-align: center;
  line-height: 120px;
	font-size: 24px;
}
.box-card .el-card__body p{
  line-height: 24px;
}
.btn-contactus{
	width: 100%;
	height: 40px;
	border: none;
	background-color: #CD454A;
	color: #fff;
	cursor: pointer;
	border-radius: 2px;
}
.modal-email-icon{
	width: 80px;
	height: 80px;
	display: inline-block;
	background: url(../../assets/img/Personal/icon_email.svg) center no-repeat;
	background-size: cover;
	margin-bottom: 23px;
}
.profile-items:before,
.profile-items:after{
  content: '';
  display: table;
}
.profile-items:after{
  clear: both;
}
.profile-card{
  margin-right: 30px;
  width: 315px;
  height: 100px;
  float: left;
  background: #FFFFFF;
  box-shadow: 0 5px 24px 0 #E7E9EE;
  background-position: 15px center;
  background-repeat: no-repeat;
  background-size: auto 60px;
  padding-left: 95px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 30px;
}
.profile-card h3{
  color: #666;
  font-size: 14px;
  font-weight: normal;
}
.profile-card h4{
  font-size: 14px;
  color: #333;
  font-weight: normal;
}
.profile-card h3,
.profile-card h4{
  line-height: 30px;
}
.profile-card h4 button{
  float: right;
  height: 30px;
  width: 80px;
  border: 1px solid #CF4447;
  border-radius: 4px;
  color: #CF4447;
  background-color: #fff;
  cursor: pointer;
}
.profile-username{
  background-image: url(../../assets/img/Personal/profile_username.svg);
}
.profile-telephone{
  background-image: url(../../assets/img/Personal/profile_telephone.svg);
}
.profile-company{
  background-image: url(../../assets/img/Personal/profile_company.svg);
}
.profile-email{
  background-image: url(../../assets/img/Personal/profile_email.svg);
}
.profile-passwd{
  background-image: url(../../assets/img/Personal/profile_passwd.svg);
}
.editusernamebox .el-input__suffix{
  color: #093;
  font-size: 16px;
}
.editusernamebox .el-input--small .el-input__inner{
  width: 200px;
}
.edittelnumberbox .el-dialog__body{
  padding-top: 0;
}
.edittelnumberbox .el-dialog__body .el-step__head.is-process{
  color:#FFF;
}
.edittelnumberbox .el-dialog__body .el-step__head.is-process .el-step__icon{
  background-color: #7290F2;
  border: 0;
}
.el-step__icon-inner{
  font-weight: normal;
}
.edittelnumberbox .el-dialog__body .el-step__title.is-process{
  font-size: 14px;
  font-weight: normal;
  color: #7290F2;
}
.edittelnumberbox .el-dialog__body .el-step__head.is-success .el-step__icon{
  background-color: #093;
  border: 0;
  color: #fff;
}
.edittelnumberbox .el-dialog__body .el-step__title.is-success{
  font-size: 14px;
  font-weight: normal;
  color: #093;
}
.edittelnumberbox .el-dialog__body .el-step__head.is-wait .el-step__icon{
  background-color: #C0C4CC;
  border: 0;
  color: #fff;
}
.edittelnumberbox .el-dialog__body .el-step__title.is-wait{
  font-size: 14px;
  font-weight: normal;
  color: #C0C4CC;
}
.verifytelnum{
  width: 400px;
  margin: auto;
  margin-top: 50px;
}
.getcodebtn{
  width: 100%;
}
.nextbtn{
  width: 250px;
  margin-top: 10px;
  /* margin-left: 150px; */
  background-color: #7290F2;
  color: #fff;
}
.setnewtelnum{
  width: 250px;
  margin: auto;
  margin-top: 50px;  
}
.setcodebtn{
  width: 250px;
  margin-top: 10px;
  background-color: #7290F2;
  color: #fff;  
}
.updatetelnumsuccess{
  width: 250px;
  margin: auto;
  margin-top: 50px;  
}
.updatetelnumsuccess h2{
  text-align: center;
  font-size: 18px;
  line-height: 30px;
}
.updatetelnumsuccess p{
  font-size: 14px;
  text-align: center;
  margin: 0;
  line-height: 26px;
}
.updatetelnumsuccess button{
  width: 120px;
  height: 40px;
  border: 0;
  color: #fff;
  background-color: #7290F2;
  border-radius: 2px;
  margin: auto;
  margin-top: 15px;
  display: block;
  cursor: pointer;
}
.edittelnumberbox .el-dialog{
  height: 500px;
}
</style>